import { connect } from 'react-redux';

import { coworkingOperatorPhoneSelector } from 'shared/store/coworking/selectors/dump/coworkingOperatorPhoneSelector';
import { IApplicationState } from 'shared/types/redux';
import { getCoworkingPageTitle } from 'shared/utils/getCoworkingPageTitle';

import { Header as HeaderComponent } from './Header';

export const mapState = (state: IApplicationState) => ({
  title: getCoworkingPageTitle(state.coworking),
  hasOperatorPhone: !!coworkingOperatorPhoneSelector(state),
});

export const Header = connect(mapState)(HeaderComponent);
